'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = memoize;
function memoize(func, hasher) {
  var memoized = function memoized() {
    var cache = memoized.cache;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var address = '' + (hasher ? hasher.apply(this, args) : args[0]);
    if (!cache.hasOwnProperty(address)) cache[address] = func.apply(this, args);
    return cache[address];
  };
  memoized.cache = {};
  return memoized;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/utilities/memoize.js
// module id = 240
// module chunks = 3 4 5